import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { K3MediaListingService } from '../medias/k3-media-listing.service';
import { MatDialog } from '@angular/material/dialog';
import { Media } from '@klickdata/core/media/src/media.model';
import { MobileService, SideNaveActionsTypes, SideNaveDataTypes } from '@klickdata/core/mobile';
import { AppScope } from '@klickdata/core/resource';
import { DialogDisplayImgComponent } from 'apps/klickdata/src/app/shared/dialog/dialog-display-img/dialog-display-img.component';
import { MatTableBase } from 'apps/klickdata/src/app/shared/table/mat-table-base';
import { filter, map, switchMap, takeUntil } from 'rxjs';
import { K3FilesListingService } from '../files/k3-files-listing.service';
import { File } from '@klickdata/core/file';
@Component({
    selector: 'app-files-listing-minimized',
    templateUrl: './files-listing-minimized.component.html',
    styleUrls: ['./files-listing-minimized.component.scss'],
    providers: [K3FilesListingService],
})
export class FilesListingMinimizedComponent extends MatTableBase<File> {
    @Output() onFileClick: EventEmitter<File> = new EventEmitter<File>();
    @Input() public columns = ['title', 'priority', 'counts'];
    AppScope = AppScope;

    constructor(
        protected listService: K3FilesListingService,
        protected mobileService: MobileService,
        protected cdr: ChangeDetectorRef
    ) {
        super(cdr, mobileService, listService);
    }
}
